<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-select
          class="search-el"
          size="mini"
          v-model="query.type"
          placeholder="类型"
        >
          <el-option label="全部" value="">全部</el-option>
          <el-option label="商品" value="1">商品</el-option>
          <el-option label="课程" value="2">课程</el-option>
          <el-option label="专题课" value="3">专题课</el-option>
          <el-option label="排期课" value="4">排期课</el-option>
        </el-select>
        <el-select
          class="search-el"
          size="mini"
          v-model="query.status"
          placeholder="状态"
          @change="changeStatus()"
        >
          <el-option label="全部" value="">全部</el-option>
          <el-option label="正常" value="1">正常</el-option>
          <el-option label="下架" value="0">下架</el-option>
        </el-select>
        <el-input
          class="search-el"
          size="mini"
          v-model="query.search"
          placeholder="请输入标题"
        ></el-input>
        <el-button type="primary" size="mini" @click="getList()">
          查询
        </el-button>
        <el-button type="primary" size="mini" @click="toCourseAdd()">
          新建课程秒杀
        </el-button>
        <el-button type="primary" size="mini" @click="toCourseTermAdd()">
          新建排期课程秒杀
        </el-button>
        <el-button type="primary" size="mini" @click="toProductAdd()">
          新建商品秒杀
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="5%"
        ></el-table-column>

        <el-table-column label="标题" align="center" min-width="20%">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="mini"
              @click="toUpdate(row.id, row.type)"
            >
              <div>{{ row.title }}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="类型" align="center" min-width="7%">
          <template slot-scope="{ row }">
            {{ type2Msg(row.type) + "ID：" + row.target_id }}
          </template>
        </el-table-column>
        <el-table-column label="有效期" align="center" min-width="13%">
          <template slot-scope="{ row }">
            起：{{ row.begin_at }}<br />
            止：{{ row.end_at }}
          </template>
        </el-table-column>
        <el-table-column
          prop="stock"
          label="商品总量"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="flash_sale_number_v"
          label="虚拟数量"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="flash_sale_number"
          label="已售数量"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="deal_amount"
          label="成交金额（元）"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column label="订单" align="center" min-width="7%">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="flashSaleProductOrder(row.id)">订单</el-button>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.status == 1" style="color: #67c23a"
                ><i class="el-icon-circle-check"></i> 已发布</span
              >
              <span v-else style="color: #909399"
                ><i class="el-icon-circle-close"></i> 未发布</span
              >
              <el-button
                type="text"
                size="small"
                style="margin-left: 5px"
                @click="
                  row.status == 1
                    ? statusSet(row.id, 0)
                    : statusSet(row.id, 1)
                "
              >
                {{ row.status == 1 ? "下架" : "发布" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <el-button
            v-if="row.status == 1"
              type="text"
              size="mini"
              @click="qrCode(row.target_id, row.course_type)"
            >
              <div>分享</div>
            </el-button>

            <el-button
              v-if="row.status == 0"
              type="danger"
              size="small"
              @click="flashSaleInfoDelete(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <!-- 二维码弹窗 -->
    <el-dialog title="二维码" :visible.sync="dialogVisible" width="50%">
      <div
        id="qrcode"
        style="margin-left: 256 /2; position: relative; left: 10%"
      ></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { qrCode, formatDate, itemTypeGetUrl } from "@/api/common";
import {
  getFlashSaleList,
  flashSaleInfoSet,
  flashSaleInfoDelete,
} from "@/api/promotion";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 15,
        search: "",
        status: "全部",
        type: "全部",
      },
    };
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    changeStatus(){
      this.query.page = 1
    },
    qrCode(id, type) {
      this.dialogVisible = true;
      this.$nextTick(function () {
        document.getElementById("qrcode").innerHTML = "";
        let qrcode = qrCode(itemTypeGetUrl(id, type));
      });
    },
    // itemTypeGetUrl(id, type) {
    //   return itemTypeGetUrl(id, type);
    // },
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
    type2Msg(type) {
      if (type == 1) return "商品";
      if (type == 2) return "课程";
      if (type == 3) return "专题课";
      if (type == 4) return "排期课";
    },
    toCourseAdd() {
      this.$router.push({
        path: "/promotion/flashSaleCourseAdd",
      });
    },
    toCourseTermAdd() {
      this.$router.push({
        path: "/promotion/flashSaleCourseTermAdd",
      });
    },
    toProductAdd() {
      this.$router.push({
        path: "/promotion/flashSaleProductAdd",
      });
    },
    toUpdate(id, type) {
      if (type == 1) {
        this.$router.push({
          path: "/promotion/flashSaleProductAdd",
          query: {
            id: id,
          },
        });
      } else if (type == 4) {
        this.$router.push({
          path: "/promotion/flashSaleCourseTermAdd",
          query: {
            id: id,
          },
        });
      } else {
        this.$router.push({
          path: "/promotion/flashSaleCourseAdd",
          query: {
            id: id,
          },
        });
      }
    },
    flashSaleProductOrder(id) {
        this.$router.push({
            path: '/promotion/flashSaleProductOrder',
            query: {
                id: id,
            }
        })
    },
    getList(str) {
      this.loading = true;
      getFlashSaleList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    flashSaleInfoDelete(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        flashSaleInfoDelete({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          }
        });
      });
    },

    statusSet(id, status) {
      flashSaleInfoSet({
        id: id,
        status: status,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style>
</style>